"use server";

import type { DialingCode, DialingCodeDetailed } from "../types/index";
import db from "../utils/prisma.js";

export async function getAllDialingCodes(): Promise<DialingCode[]> {
  return await db.dialingCode.findMany({
    select: {
      code: true,
      root: true,
      suffix: true,
      example: true,
    },
    orderBy: { code: "asc" },
  });
}

export async function getDialingCodeByCode(
  dialingCode: string
): Promise<DialingCodeDetailed | null> {
  if (!dialingCode) return null;

  return await db.dialingCode.findUnique({
    where: { code: dialingCode },
    select: {
      code: true,
      root: true,
      suffix: true,
      example: true,
      country: {
        select: {
          code: true,
          name: true,
        },
      },
      states: {
        select: {
          id: true,
          name: true,
        },
      },
    },
  });
}

export async function getDialingCodesOfCountry(
  countryCode: string
): Promise<DialingCode[]> {
  if (!countryCode) return [];

  return await db.dialingCode.findMany({
    where: { countryCode },
    select: {
      code: true,
      root: true,
      suffix: true,
      example: true,
    },
    orderBy: { code: "asc" },
  });
}

export async function getDialingCodeOfState(
  stateId: number
): Promise<DialingCodeDetailed | null> {
  if (!stateId) return null;

  const state = await db.state.findUnique({
    where: { id: stateId },
    select: {
      dialingCode: {
        select: {
          code: true,
          root: true,
          suffix: true,
          example: true,
        },
      },
      country: {
        select: {
          phoneCodes: {
            select: {
              code: true,
              root: true,
              suffix: true,
              example: true,
            },
            orderBy: { code: "asc" },
          },
        },
      },
    },
  });

  return state?.dialingCode || state?.country?.phoneCodes?.[0] || null;
}
